import React from "react";

interface ErrorOverlayProps {
    errorMessage?: string | null;
}

const ErrorOverlay: React.FC<ErrorOverlayProps> = () => {
    return (
        <div className={`os-app-row os-flex os-flex-col os-gap-4 os-w-full os-items-center os-bg-white os-h-full os-p-12`}>
            <div className="os-flex os-flex-col os-justify-center os-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                     stroke="currentColor" className="os-size-24 os-mb-6" height={"96px"} width={"96px"}>
                    <path strokeLinecap="round" strokeLinejoin="round"
                          d="M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"/>
                </svg>
                <div className={"os-text-xl os-font-bold"}>Sorry, something went wrong.</div>
                <p>{"Please contact us to place a booking."}</p>
            </div>
        </div>
    );
};

export default ErrorOverlay;